import { useMemo } from 'react';
import type { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

type Props = Readonly<{ viewportSize: 'small' | 'normal' }>;

type BoxProps = ComponentPropsWithoutRef<typeof Box>;

export const ResponsiveBox: React.FC<PropsWithChildren<Props & BoxProps>> = ({
	children,
	viewportSize: size,
	...rest
}) => {
	const display = useMemo(() => (size === 'small' ? ['block', 'none'] : ['none', 'block']), [size]);

	return (
		<Box {...rest} sx={{ display }}>
			{children}
		</Box>
	);
};
